<div class="detail-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
	<ng-container *ngIf="resourceDetail?.description">
		<div class="detail-content-header" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">

				<div class="descrip-block">
					<app-readability [length]="200" [canRead]="true">
						<content>
							{{resourceDetail?.description}}
						</content>
					</app-readability>
				</div>
			</div>
		</div>
	</ng-container>
	<div class="detail-content-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
		<div class="knowledge-card" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" class="submission-block">
				<!-- <div class="block-title">{{locale.translate('playlist_item')}}</div> -->
				<div class="submission-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
					<ng-container *ngIf="!resourceDetail?.playlistData?.length">
						<div fxLayout="row" fxLayoutAlign="start start">
							<div fxFlex="0 1 760px" fxFlex.xs="auto" class="no-data" fxLayout="column" fxLayoutAlign="center center"
								fxLayoutGap="15px">
								<!-- <p>
									{{locale.translate('no_resource_added_for_playlist')}}
								</p> -->
								<p>{{locale.translate('this_playlist_is_empty')}}</p>
								<ng-container *ngIf="resourceDetail?.resourceAction?.addResource">
									<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
										<button mat-stroked-button class="submit-btn" type="button" #addPlaylistItemEl
											(click)="addPlaylistItem(addPlaylistItemEl)">
											{{locale.translate('add_resources')}}
										</button>
									</div>
									<p class="body-text" fxLayout="row" fxLayoutAlign="center center">
										{{locale.translate('you_may_also_add_resources_from_resource_screen')}}
									</p>
								</ng-container>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="resourceDetail?.playlistData?.length">
						<div fxLayout="row" fxLayoutAlign="start start">
							<loader [loader]="loader" [type]="'general'"></loader>
							<div fxFlex="0 1 760px" fxFlex.xs="auto" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="0px"
								class="content-image-card" cdkDropList [cdkDropListData]="resourceDetail?.playlistData"
								(cdkDropListDropped)="drop($event)"
								[cdkDropListDisabled]="resourceDetail?.playlistData?.length === 1 || disableDrag">
								<ng-container
									*ngFor="let data of resourceDetail?.playlistData; let i = index; trackBy: gfService.trackByID.bind({'key': 'resourceID'})">
									<div class="dragger-item" fxLayout="column" fxLayoutGap="5px" [ngClass]="{'dragging': data?.dragging}"
										cdkDrag cdkDragBoundary=".content-image-card" (cdkDragStarted)="cdkDragStarted($event, data)"
										(cdkDragEnded)="cdkDragEnded($event, data)">
										<div class="dragger-placeholder" *cdkDragPlaceholder></div>
										<ng-container *ngIf="data?.resourceType?.key === 'answer'">
											<div fxLayout="row" fxLayoutAlign="start-center" fxLayoutGap="10px">
												<ng-container *ngIf="!(resourceDetail?.playlistData?.length === 1 || disableDrag)">
													<div fxLayoutAlign="center center">
														<mat-icon svgIcon="drag_and_drop" class="drag-icon" cdkDragHandle></mat-icon>
													</div>
												</ng-container>
												<app-question-card [data]="data" (profile)="profileInfo(data)" (users)="getUsersProfile(data)"
													(detail)="detail(data)"
													(remove)="alertPopup('delete',data, {index:i, actionElement:$event.actionElement})">
												</app-question-card>
											</div>
										</ng-container>
										<ng-container *ngIf="['internalEvent', 'externalEvent'].includes(data?.resourceType?.key)">
											<div fxLayout="row" fxLayoutAlign="start-center" fxLayoutGap="10px">
												<ng-container *ngIf="!(resourceDetail?.playlistData?.length === 1 || disableDrag)">
													<div fxLayoutAlign="center center">
														<mat-icon svgIcon="drag_and_drop" class="drag-icon" cdkDragHandle></mat-icon>
													</div>
												</ng-container>
												<app-event-card [data]="data" (detail)="detail(data)"
													(remove)="alertPopup('delete',data, {index:i, actionElement:$event.actionElement})">
												</app-event-card>
											</div>
										</ng-container>
										<ng-container
											*ngIf="!['answer', 'internalEvent', 'externalEvent'].includes(data?.resourceType?.key)">
											<div class="play-list-item" fxLayout="row" fxLayoutAlign="start-center" fxLayoutGap="10px"
												[ngClass]="{ 'processing': data?.deleting}">
												<ng-container *ngIf="!(resourceDetail?.playlistData?.length === 1 || disableDrag)">
													<div fxLayoutAlign="center center">
														<mat-icon svgIcon="drag_and_drop" class="drag-icon" cdkDragHandle></mat-icon>
													</div>
												</ng-container>
												<app-content-image-card [record]="data" (profile)="profileInfo(data)" (detail)="detail($event)"
													(remove)="alertPopup('delete',data, {index:i, actionElement:$event.actionElement})">
												</app-content-image-card>
											</div>
										</ng-container>
									</div>
								</ng-container>
							</div>
						</div>
						<ng-container *ngIf="resourceDetail?.resourceAction?.addResource">
							<div class="add-resource" fxLayout="row" fxLayoutAlign="start center">
								<p class="hyperlink" (click)="addPlaylistItem()">{{locale.translate('add_resources')}}</p>
							</div>
						</ng-container>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="feature-placeholder fx-column fx-start-stretch"
			[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
		</div>
	</div>
</div>
